export const HERO = 'hero'
export const HERO_TWO = 'hero-two'
export const THREE_COLUMN = 'three-column'
export const TWO_COLUMN = 'two-column'
export const INLINE_BUTTON_HEADER = 'inline-button-header'
export const FEATURED_PROJECTS = 'featured-projects'
export const FULL_WIDTH_IMAGE = 'full-width-image'
export const TABLE = 'table'
export const PARAGRAPH = 'paragraph'
export const HEADINGS = 'headings'
export const LINK = 'link'
export const FOOTER = 'footer'
